import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CompanyMenuTree = ({ companyIds }) => {
  const [modules, setModules] = useState([]);
  const [moduleMenus, setModuleMenus] = useState({});

  useEffect(() => {
    // Fetch company modules
    axios.get(`http://localhost:8080/webnet-hms/api/company-modules/company/${companyIds}/active-modules/`)
      .then(res => {
      const rawData = res.data.data;
      const flatData = rawData.flat();
        setModules(flatData);
        flatData.forEach(mod => {
          axios.get(`http://localhost:8080/webnet-hms/api/menus/module/${mod.moduleId}`)
            .then(menuRes => {
              setModuleMenus(prev => ({
                ...prev,
                [mod.moduleId]: menuRes.data
              }));
            });
        });
      });
  }, [companyIds]);

  return (
    <ul className="sidebar-menu">
        <li className="active current-page">
            <a href="/dashboard-company">
              <i className="ri-home-6-line" />
              <span className="menu-text">Dashboard</span>
            </a>
          </li>
      {modules.map(mod => (
        <li key={mod.moduleId} className="treeview">
          <a href="#!">
            <i className={mod.moduleIcon || "ri-apps-line"} />
            <span className="menu-text">{mod.moduleName}</span>
          </a>

          <ul className="treeview-menu">
            {(moduleMenus[mod.moduleId] || []).map(menu => (
              <li key={menu.menuId}>
                <a href={menu.menuUrl}>{menu.menuName}</a>
              </li>
            ))}
          </ul>
        </li>
      ))}

      <li>
        <a href={"/login"} onClick={() => sessionStorage.clear()}>
          <i className="ri-login-circle-line" />
          <span className="menu-text">Logout</span>
        </a>
      </li>
    </ul>
  );
};

export default CompanyMenuTree;
